import React from 'react';
import InfoTooltip from 'shared/components/info-tooltip';
import CostComparisonWithAverage from './cost-comparison-with-average';
import {NationalCollegeData} from 'src/types/college-profile';

interface Props {
  college: Record<string, number>;
  nationalCollegeData: NationalCollegeData;
}

const CompareSalaryAfterGraduation = ({college, nationalCollegeData}: Props) => {
  if (!college.salaryAfterGraduation) {
    return null;
  }

  const salaryTooltip = (
    <InfoTooltip className="college-profile-tooltip">
      The median earnings of former students who received federal financial aid, at 10 years after
      entering the school.
    </InfoTooltip>
  );

  return (
    <CostComparisonWithAverage
      label="Salary After Attending"
      tooltip={salaryTooltip}
      dataSource={nationalCollegeData}
      attributeInSource="avgSalaryAfterGraduation"
      attributeOnCollege="salaryAfterGraduation"
      college={college}
    />
  );
};

export default CompareSalaryAfterGraduation;
